<template>
  <van-tabbar
    route
    placeholder
    v-model="active"
    :before-change="beforeChange"
    :class="[layoutVersion, 'tabbar']"
  >
    <!-- <van-tabbar route placeholder v-model="active"> -->
    <van-tabbar-item
      replace
      v-for="(item, index) in tabbarList"
      :key="item.id"
      :to="item.to"
      :class="['tabbar-item', active === index ? 'active' : '']"
    >
      <div class="custom-tabbar flex-col-center">
        <div class="ignore flex-center icon-wrapper">
          <img
            :src="active === index ? item.icon.active : item.icon.inactive"
            alt="icon"
            class="icon-img"
          />
        </div>
        <span>{{ item.title }}</span>
      </div>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'TabBar',
    components: {},
    props: ['tabbarList', 'value'],
    data() {
      return {
        active: this.value,
      }
    },
    computed: {
      ...mapState(['layoutVersion']),
    },
    created() {},
    mounted() {},
    watch: {
      value(val) {
        this.active = val
      },
      active(val) {
        this.$emit('input', val)
      },
    },
    methods: {
      beforeChange(index) {
        this.active = index
        this.$router.push({
          path: this.tabbarList[index].to,
          query: this.$route.query,
        })
        this.$emit('beforeChange', index)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .van-tabbar__placeholder {
    .van-tabbar {
      box-shadow: 0 -8px 14px 0 rgba(0, 0, 0, 0.15);
    }
    .van-tabbar-item {
      justify-content: flex-start;
      font-weight: bold;
      &.van-tabbar-item--active {
        color: #000;
      }
    }
  }

  .tabbar {
    position: fixed;
    left: 0;
    bottom: 0;
    .tabbar-item {
      .icon-wrapper {
        width: 90px;
        height: 90px;
        border-radius: 50%;
        & > img {
          height: 100px;
        }
      }
    }
    &.version-2-2 {
      font-family: 'Roboto';
      ::v-deep .van-tabbar {
        height: 180px;
        box-shadow: 0px -10px 30px rgba(199, 183, 176, 0.1);
      }
      .tabbar-item {
        margin-top: 5px;
        .icon-wrapper {
          width: 94px;
          height: 94px;
          border-radius: 50%;
          margin-bottom: 5px;
          & > img {
            height: 100%;
          }
        }
        .custom-tabbar {
          & > span {
            font-weight: 400;
            font-size: 33px;
            line-height: 39px;
            color: black;
          }
        }
        &.active {
          .icon-wrapper {
            background: $orange-linear;
            & > img {
              height: 90px;
            }
          }
          .custom-tabbar {
            & > span {
              font-weight: 500;
              color: $orange;
            }
          }
        }
      }
    }
  }
</style>
